import { BrandLink, Faqs } from './shared'

export const newCarsMonthlyBudgets = [
  {
    label: 'Cars under £250',
    href: '/new-cars?financeType=any&toPrice=250',
  },
  {
    label: 'Cars under £300',
    href: '/new-cars?financeType=any&toPrice=300',
  },
  {
    label: 'Cars under £400',
    href: '/new-cars?financeType=any&toPrice=400',
  },
  {
    label: 'Cars under £500',
    href: '/new-cars?financeType=any&toPrice=500',
  },
  {
    label: 'Cars over £500',
    href: '/new-cars?financeType=any&fromPrice=500',
  },
]

export const newCarsFAQs: Faqs[] = [
  {
    label: 'How do I buy a new car?',
    href: 'https://help.cinch.co.uk/hc/en-gb/articles/34999229607069-How-do-I-purchase-a-new-car',
  },
  {
    label: 'What are my finance options?',
    href: 'https://help.cinch.co.uk/hc/en-gb/articles/34999719235229-What-are-my-finance-options-on-a-new-car-purchase',
  },
  {
    label: 'Can I test drive a new car?',
    href: 'https://help.cinch.co.uk/hc/en-gb/articles/34999694672797-Can-I-test-drive-a-new-car',
  },
  {
    label: "Why we're partnering with Marshall to sell new cars?",
    href: 'https://help.cinch.co.uk/hc/en-gb/articles/27062254452125-What-is-the-relationship-between-cinch-and-Marshall-Motor-Group',
  },
]

export const newCarBrandLinks: BrandLink[] = [
  {
    type: 'link',
    label: 'BYD',
    href: '/new-cars/byd',
    imageSrc: 'https://a.storyblok.com/f/143588/40x40/ee9bcade88/byd-logo.svg',
  },
  {
    type: 'link',
    label: 'Nissan',
    href: '/new-cars/nissan',
    imageSrc:
      'https://a.storyblok.com/f/143588/40x40/5d841de668/nissan-logo.svg',
  },
  {
    type: 'link',
    label: 'Hyundai',
    href: '/new-cars/hyundai',
    imageSrc:
      'https://a.storyblok.com/f/143588/40x40/670f1842ed/hyundai-logo.svg',
  },
  {
    type: 'link',
    label: 'Chery',
    href: '/new-cars/chery',
    imageSrc:
      'https://a.storyblok.com/f/143588/40x40/ae6a774d05/chery-logo.svg',
  },
  {
    type: 'link',
    label: 'Geely',
    href: '/new-cars/geely',
    imageSrc:
      'https://a.storyblok.com/f/143588/40x40/a2a2529400/geely-logo.svg',
  },
  {
    type: 'link',
    label: 'JAECOO',
    href: '/new-cars/jaecoo',
    imageSrc:
      'https://a.storyblok.com/f/143588/40x40/f52c9047cd/jaecoo-logo.svg',
  },
  {
    type: 'link',
    label: 'OMODA',
    href: '/new-cars/omoda',
    imageSrc:
      'https://a.storyblok.com/f/143588/40x40/7969da9943/omoda-logo.svg',
  },
]
